import Alpine from 'alpinejs';
import editCompany from "./components/edit-company";

import "./components/mega-menu";
import "./components/search-form";
import "./components/product";
import "./components/quantity";
import "./components/product-see-also";
import "./components/cart";
import "./components/errors";
import "./components/company";
import "./components/auth";
import "./components/auth-reset";
import "./components/special-offers";
import "./components/catalog";
import "./components/dashboard";
import "./components/classic-checkout";
import "./components/orders-list-filter";
import "./components/add-to-cart-badge";

// import Swiper from 'swiper';
// import 'swiper/css';

document.addEventListener("DOMContentLoaded", e => {
	console.log("Kitan Portal JS App Start");

	fetch('/wp-content/themes/kitan-portal/assets/images/icons.svg')
		.then(r => r.text())
		.then(svg => {
			const div = document.createElement('div');
			div.style.display = 'none';
			div.innerHTML = svg;
			div.firstElementChild.style.display = "none";
			document.body.prepend(div.firstElementChild);
		});
});

//Register Alpine.js components 
if (typeof window !== 'undefined') {
	window.addEventListener('DOMContentLoaded', () => {
		const _load = Promise.resolve(Alpine.start());
		_load.then(() => {
			console.info('Started alpine');
		});
	})

	document.addEventListener('alpine:init', () => {
		// window.Alpine = Alpine;
		// window.editCompany = editCompany;
		Alpine.data('editCompany', editCompany);
	});
}
